<template>
    <Link class="btn btn-secondary">{{ $t('button.ticket') }}</Link>
</template>

<script setup lang="ts">
import {Link} from "@inertiajs/vue3";
</script>

<style scoped>

</style>
